import React from 'react';
import { DefaultIconProps } from '@gamiphy/icons/types';

const CashbackIcon: React.FC<DefaultIconProps> = ({
  className, width, height, textColor = '#fff',
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 24 24">
    <g data-name="Grupo 140548">
      <g opacity="0.5">
        <path d="M0 0h24v24H0z" style={{ fill: 'none', fillRule: 'evenodd' }} />
        <path d="M12 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10zm0-2a8 8 0 1 0-8-8 8 8 0 0 0 8 8zm-3.5-6H14a.5.5 0 1 0 0-1h-4a2.5 2.5 0 0 1 0-5h1V6h2v2h2.5v2H10a.5.5 0 1 0 0 1h4a2.5 2.5 0 1 1 0 5h-1v2h-2v-2H8.5z" fill={textColor} />
      </g>
      <g data-name="money-dollar-circle-line">
        <path data-name="Path" d="M0 0h24v24H0z" style={{ fill: 'none', fillRule: 'evenodd' }} />
        <path data-name="Shape" d="M12 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10zm0-2a8 8 0 1 0-8-8 8 8 0 0 0 8 8z" fill={textColor} />
      </g>
    </g>
  </svg>
);

export default CashbackIcon;
